import { observer } from 'mobx-react-lite';

import { Button, CoachMark } from '@/components/ui';

import { coachMarks, type CoachMarkSpec } from './coach-marks.state';

import type { ComponentPropsWithoutRef, ReactNode } from 'react';

interface CoachMarkTipProps extends Pick<
  ComponentPropsWithoutRef<typeof CoachMark.Content>,
  'side' | 'align' | 'sideOffset'
> {
  mark: CoachMarkSpec;
  target?: string;
  children: ReactNode;
}

export const CoachMarkTip = observer(function CoachMarkTip({
  mark,
  target,
  children,
  ...contentProps
}: CoachMarkTipProps) {
  return (
    <CoachMark.Root
      open={coachMarks.isOpen(mark, target)}
      onOpenChange={(open) => {
        if (!open) coachMarks.dismiss(mark, target);
      }}
    >
      {children}
      <CoachMark.Content {...contentProps} width={mark.width}>
        <CoachMark.Title>{mark.title}</CoachMark.Title>
        <CoachMark.Description>{mark.description}</CoachMark.Description>
        <CoachMark.Footer>
          <CoachMark.Dismiss asChild>
            <Button size="sm">Got it</Button>
          </CoachMark.Dismiss>
        </CoachMark.Footer>
      </CoachMark.Content>
    </CoachMark.Root>
  );
});
